<!--
    Program: CertPassChange.vue
    Author: SDL
    Description: 
    Created: 2020.03.20
-->

<template>
    <div id="contents">
        <div class="contents_wrap">
            <!-- <OBJECT
                id="unetTS"
                classid="clsid:1F529230-5B55-4C17-80A0-70F19821A033"
                codebase="/static/setup/SecuiGSPNIE.cab#Version=4,0,0,7"
                width="0"
                height="0"
            ></OBJECT> -->
<!-- CB Trustnet Client 교체 22.9.19
<!--             <OBJECT -->
<!--                 id="TrustNETCAClient" -->
<!--                 classid="clsid:C4A97BC6-0E15-46C1-9A7D-2E9465E51C48" -->
<!--                 codebase="/static/setup/SecuiGSPNIE.cab#Version=1,0,0,1" -->
<!--                 width="0" -->
<!--                 height="0" -->
<!--             ></OBJECT> -->
            <!-- contents -->
            <!-- contents_head -->
            <h2 class="pg_title">{{pageTitle}}</h2>
            <!-- breadcrumbs -->
            <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            <!-- //breadcrumbs -->
            <!-- //contents_head -->

            <!-- Information tit -->
            <div
                class="sub_tit"
            >Please enter the fields below, then press the 'Change Password' button.</div>
            <!-- //Information tit -->
            <!-- detail_Information -->
            <table class="create_table">
                <colgroup>
                    <col width="*" />
                </colgroup>
                <tbody>
                    <tr>
                        <td>
                            <span class="clearable w40">
                                <input
                                    type="password"
                                    class="text_input w100"
                                    placeholder="Old Certificate Password"
                                    maxlength="30"
                                    v-model="oldPassword"
                                    v-clearable
                                />
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <span class="clearable w40">
                                <input
                                    type="password"
                                    class="text_input w100"
                                    placeholder="New Certificate Password"
                                    v-model="newPassword"
                                    maxlength="30"
                                    v-validation
                                    v-clearable
                                />
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <span class="clearable w40">
                                <input
                                    type="password"
                                    class="text_input w100"
                                    placeholder="Confirm New Certificate Password"
                                    v-model="newPasswordConfirm"
                                    maxlength="30"
                                    v-validation
                                    v-clearable
                                />
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <!-- //detail_Information -->
            <!-- page btn -->
            <div class="btn_wrap_full topLine">
                <div class="btn_right">
                    <a
                        href="javascript:"
                        class="btn_blue"
                        title
                        @click="onChangePassword"
                    >Change Password</a>
                </div>
            </div>
            <!-- //page btn -->
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
// import store from '@/vuex/store';
import SDLLocale from '@/mixin/SDLLocale';
import { SDLUtil, CertUtil } from '@/utils';

import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';
import * as unet from '/static/js/trustnet/TrustNetJsEX';

/* 컴포넌트에서 사용할 스크립트 */
export default {
    name: 'cert-password-change',
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
    },
    // props: [],
    // computed: {
    // },
    data() {
        return {
            pageTitle: '',

            userId: '',
            oldPassword: '',
            newPassword: '',
            newPasswordConfirm: '',
        };
    },
    created() {
    	TrustNetEX.setUTF8(true);	// UTF8 속성    	
        this.init();
    },

    mounted() {},

    methods: {
        async init() {
            SDLUtil.showLoadingBar(true);
            const data = await this.fetchInitData();
            if (data.result === true) {
                this.userId = data.userId;
                const loginLock = data.loginLockYN === 'Y';
                const monthLock = data.monthLockYN === 'Y';
                this.checkLock(loginLock, monthLock);
            } else {
                SDLUtil.alert({
                    title: 'Error!',
                    msg: 'Failed to fetch initial data.<br>Please log out and try again.',
                });
            }
            SDLUtil.showLoadingBar(false);

            this.$nextTick(() => {
            	//CB Trustnet Client 교체 22.9.19    	        	
//              if (!this.checkBrowser()) return;
//              if (!this.checkTrustNetInstalled()) return;
            });
        },

        fetchInitData() {
            const path = '/basis/certificate/CertPassChange.skp';
            return SDLUtil.getRequest(path).catch(err => {
                if (err.data.error.code === 'HHP_LOGIN_REQUIRED') {
                    SDLUtil.alert({
                        title: 'Login Required!',
                        msg: 'Please login first in order to access the page.',
                        onOkEvt: () => {
                            this.$router.push({ name: 'anysvcCertHome' });
                        },
                    });
                }
                return err;
            });
        },

        checkBrowser() {
            if (SDLUtil.isIE11()) {
                return true;
            }
            SDLUtil.alert({
                title: 'Unsupported Browser!',
                msg: 'Internet Explorer 11 is required to use the feature on this page.',
            });
            return false;
        },

        checkLock(loginLock, monthLock) {
            // console.log('LOCKs', loginLock, monthLock);
            let msg = '';

            if (monthLock) {
                msg += "[ Unlock the 1-month lock ]<br>You haven't logged in to your account for more than a month.";
            }

            if (loginLock) {
                if (msg != '') {
                    msg += '<br>';
                }
                msg += '[ Unlock the certificate ]<br>Login failed for more than 5 times.';
            }

            msg += '<br>Please unlock the account by using Other request page.';

            const result = !(monthLock || loginLock);
            if (!result) {
                SDLUtil.alert({
                    title: 'Account Locked!',
                    msg,
                    okLabel: 'Go to "Other Request" page',
                    onOkEvt: () => {
                        this.$router.push({ name: 'hhpOtherRequest' });
                    },
                });
            }
            return result;
        },

        checkTrustNetInstalled() {
            if (!CertUtil.isTrustNetInstalled()) {
                SDLUtil.alert({
                    msg: 'Please install or allow TrustNET Solution to run.',
                });
                return false;
            }
            return true;
        },

        onChangePassword() {
//CB Trustnet Client 교체 22.9.19    	        	
//             if (!this.checkBrowser()) return;
//             if (!this.checkTrustNetInstalled()) return;

            if (!this.validateInput()) return;
            this.changePassword(this.userId, this.oldPassword, this.newPassword);
        },

        validateInput() {
            const validations = [
                {
                    condition: this.oldPassword.length < 4,
                    msg: 'Please enter the old password. At least 4 characters long.',
                },
                {
                    condition: this.newPassword.length < 8,
                    msg: 'Please enter new password with 8 characters or more.',
                },
                {
                    condition: this.newPassword !== this.newPasswordConfirm,
                    msg: 'New password and Password Confirm field must match.',
                },
                {
                    condition: this.newPassword.endsWith(' ') || this.newPassword.startsWith(' '),
                    msg: 'New password cannot start or end with space.',
                },
                {
                    condition: this.newPassword.toUpperCase().includes(this.userId.toUpperCase()),
                    msg: `New password cannot include '${this.userId}'.`,
                },
            ];

            let msgArray = [];
            // console.log('validations', validations);
            validations.forEach(item => {
                // console.log('item', item);
                if (item.condition) {
                    msgArray.push('- ' + item.msg);
                }
            });
            // console.log('msgArray', msgArray);

            if (msgArray.length > 0) {
                const title = 'Invalid input';
                const msg = msgArray.join('<br>');
                SDLUtil.alert({ title, msg });
                return false;
            }

            return true;
        },

        async changePassword(userId, oldPassword, newPassword) {
            const sId = userId;
            const cCertPwd = oldPassword;
            const nCertPwd = newPassword;
            const user_dn = 'cn=' + sId + ',ou=SAMSUNGSCMS,o=SAMSUNG,c=KR'; // SCMS 인증서 정책

            
			///////////////////////////////////////////////////////////////////
        	// 인증서 비밀번호 변경(Handler)
        	const changeCertPwd = new Promise((resolve) => {
        		TrustNetEX.tnChangeLocalCertPwd(user_dn, cCertPwd, nCertPwd, function(r) {
        			resolve(r);
        		});
        	});

        	// 비밀번호 변경 결과
        	let _retChangeCertPwd = await changeCertPwd;
        	//console.log("await changeCertPwd ::", _retChangeCertPwd)
        	///////////////////////////////////////////////////////////////////
            if (_retChangeCertPwd.retCode == 0) {
                const title = 'Change Succeeded!';
                const msg = 'Changed certificate password successfully!';
                SDLUtil.alert({
                    msg,
                    title,
                    onOkEvt: () => {
                        this.resetInput();
                    },
                });
            } else {

//                 if (errorCode.toString() == '-1505') {
//                     SDLUtil.alert({
//                         title: 'Failed',
//                         msg: 'Wrong Password.',
//                     });
//                 } else {
                    SDLUtil.alert({
                        title: 'Failed',
                        msg: 'Not Changed certificate password',
                    });
//                 }
                return;
            }
        },
        changePassword_20220919(userId, oldPassword, newPassword) {
            const sId = userId;
            const cCertPwd = oldPassword;
            const nCertPwd = newPassword;
            const user_dn = 'CN=' + sId + ',OU=SAMSUNGSCMS,O=SAMSUNG,C=KR'; // SCMS 인증서 정책

            const trustnetCASObj = document.getElementById('TrustNETCAClient');

            const ret = trustnetCASObj.ChangePrivKeyPasswd(user_dn, cCertPwd, nCertPwd);
            if (ret == 0) {
                const title = 'Change Succeeded!';
                const msg = 'Changed certificate password successfully!';
                SDLUtil.alert({
                    msg,
                    title,
                    onOkEvt: () => {
                        this.resetInput();
                    },
                });
            } else {
                const errorCode = trustnetCASObj.GetErrorCode();
                const errorMsg = trustnetCASObj.GetErrorString();
                if (errorCode.toString() == '-1505') {
                    SDLUtil.alert({
                        title: 'Failed',
                        msg: 'Wrong Password.',
                    });
                } else {
                    SDLUtil.alert({
                        title: 'Failed',
                        msg: '[' + errorCode + '] ' + errorMsg,
                    });
                }
                return;
            }
        },

        onReset() {
            this.resetInput();
        },

        resetInput() {
            this.oldPassword = '';
            this.newPassword = '';
            this.newPasswordConfirm = '';
        },
    },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/certificate/CertPassChange.vue